import { z } from 'zod'
import { wrapWithNonNullFallback } from '../utils'

export const apiAlertFeedbackSchema = z.object({
  is_positive_feedback: z.boolean(),
  comment: wrapWithNonNullFallback(z.string().nullable().optional(), ''),
  created_at: z.string(),
  updated_at: z.string(),
})

export const alertFeedbackSchema = apiAlertFeedbackSchema.transform((data) => {
  const { is_positive_feedback, comment, created_at, updated_at } = data

  return {
    isPositiveFeedback: is_positive_feedback,
    comment,
    createdAt: created_at,
    updatedAt: updated_at,
  }
})

export type AlertFeedback = z.infer<typeof alertFeedbackSchema>
